import {
    useCallback, useMemo,
} from 'react'
import {
    prepareLogisticsCostsToBulkEdit,
} from 'app/Apps/Rates/RateCards/LogisticsCosts/LogisticsCosts.utils'

import useEnumValues from 'app/hooks/useEnumValues'
import useLabel from 'app/hooks/useLabel'
import SkyNetSpreadSheet, {
    getEditedItems,
    SkyNetSpreadSheetControlPanel,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'

import useSyncState from 'app/hooks/useSyncState'
import {
    LogisticsCostsItem,
} from '../LogisticsCosts.types'
import getConfig from './LogisticsCostsSpreadsheet.config'

export default function LogisticsCostsSpreadsheet({
    data,
    onSave,
    onCancel,
}: Readonly<{
    data: LogisticsCostsItem[];
    onSave: (v: LogisticsCostsItem[], o?: AsyncMutationOptions) => void;
    onCancel?: (...args: any[]) => void;
}>) {
    const getAllowedValues = useEnumValues()
    const getLabel = useLabel()
    const {
        value, setValue,
    } = useSyncState<LogisticsCostsItem[]>(data)

    const editedItems = useMemo(() => {
        return getEditedItems({
            allItems: prepareLogisticsCostsToBulkEdit(value),
            initData: prepareLogisticsCostsToBulkEdit(data),
        })
    }, [
        data,
        value,
    ])

    const handleSave = useCallback(
        async (options?: { onSuccess?: (...a: any) => void }) => {
            return onSave(editedItems, options)
        },
        [
            onSave,
            editedItems,
        ],
    )

    const config = useMemo(() => {
        return getConfig({
            getLabel,
            getAllowedValues,
        })
    }, [
        getLabel,
        getAllowedValues,
    ])

    const edited = Boolean(editedItems.length)

    return (
        <SkyNetSpreadSheetControlPanel
            onSave={handleSave}
            onCancel={onCancel}
            edited={edited}
            isFullScreen
        >
            <SkyNetSpreadSheet
                config={config}
                value={value}
                onChange={setValue}
            />
        </SkyNetSpreadSheetControlPanel>
    )
}
